module.exports = __webpack_public_path__ + "static/img/02344_5.3fd4af2.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/pages/home/img/02344_5.jpg
// module id = J93q
// module chunks = 1